module.exports = __webpack_public_path__ + "img/141.5.cc95e2ba.png";